/**
 * Токен из ссылки письма лежит во фрагменте (`#token=…`): он не уходит на сервер статики
 * и в Referer. Читаем один раз и убираем из адресной строки и истории браузера.
 */
export function takeFragmentToken(): string | null {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const token = params.get('token');
  if (token !== null) {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }
  return token;
}
